import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [
    {
        cameraLocationId: 'CAR0103',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Editorial Cartoons | الكاريكاتير السياسي',
        ObjectId:null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: 'NOV0501',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Graphic Novels | الروايات التصويرية',
        ObjectId:null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'COM0102',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Comics | الشرائط المصورة',
        ObjectId:null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: 'ILL0103',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Graphic Illustartion | الرسوم التصويرية و التعبيرية',
        ObjectId:null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: 'CHI0101',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Children's Book Illustration | رسوم كتب الأطفال`,
        ObjectId:null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: 'LIF0501',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Lifetime Achievement Award | جائزة انجازات العمر`,
        ObjectId:null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'CGA0301',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Comics Guardian Award | جائزة راعي الشرائط المصورة`,
        ObjectId:null,
        displayMesh: 'N',
    },

];

export {CameraLocationsDB, FLOOR_NUMBER};
